import React from 'react';
import styled from 'styled-components';

const ImageContainer = styled.div`
  background: #f7f7f7;
  padding-bottom: 60px;
  text-align: center;

  img {
    height: 478px;
  }
`;

function AssetsSection({ input }) {
  return (
    <div>
      <ImageContainer>
        <img src={input.primary.image.url} />
      </ImageContainer>
    </div>
  );
}

export { AssetsSection };
